module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0104.jpg?v=c3557673";